module.exports = __webpack_public_path__ + "img/faustino.b58759d3.jpg";